import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { storeWorkProcessApi } from '@/api/store-work-process';
import StoreWorkProcess from '@/entity/StoreWorkProcess';
import PaginationOutput from '@/helpers/PaginationOutput';
export const storeWorkProcessService = {
    async getItemList(param = {
        pageNumber: 1,
        pageSize: '20',
    }) {
        const params = new QueryParameterBuilder()
            .addPage(param.pageNumber)
            .addSize(param.pageSize);
        const response = await storeWorkProcessApi.getItemList(params.build());
        return PaginationOutput.adaptorFactory(response, StoreWorkProcess);
    },
    async getItem(id) {
        const response = await storeWorkProcessApi.getItem(id);
        return new StoreWorkProcess(response.data.data);
    },
    async updateItem(serviceData) {
        const response = await storeWorkProcessApi.putItem(serviceData.reqBody.id, serviceData.createReqBody());
        return response;
    },
    async createItem(serviceData) {
        const response = await storeWorkProcessApi.postItem(serviceData.createReqBody());
        return response.data;
    },
    async deleteItem(id) {
        const response = await storeWorkProcessApi.deleteItem(id);
        return response;
    },
    /**
     * 답변 등록
     */
    async createReply(serviceData) {
        const response = await storeWorkProcessApi.postReply(serviceData.createReqBody());
        return response.data;
    },
};
